module.exports = __webpack_public_path__ + "img/gh.a25f96eb.svg";